import { render, staticRenderFns } from "./admin-main.vue?vue&type=template&id=5b30e9ec&scoped=true"
import script from "./admin-main.vue?vue&type=script&lang=js"
export * from "./admin-main.vue?vue&type=script&lang=js"
import style0 from "./admin-main.vue?vue&type=style&index=0&id=5b30e9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30e9ec",
  null
  
)

export default component.exports